import React from 'react';
import { Skeleton } from '@material-ui/lab';
import Slider from 'react-slick';
import { Row, Col, Grid } from "react-bootstrap";

import { SkeletonCard } from './';

const SkeletonGrid = ({ title,children }) => {
  const windowWidth = window.innerWidth;
  const settings_courses = {
    autoplay: false,
    dots: false,
    speed: 500,
    slidesToShow: (windowWidth <= 987 ? 2 : 4),
    slidesToScroll: (windowWidth <= 987 ? 2 : 4)
  };
  return (
    <Grid className="rowCarousel">
      <Row>
        <Col md={12}>
          <Skeleton variant="rect">
            <h2>{title}</h2>
          </Skeleton>
        </Col>
      </Row>
      <Slider {...settings_courses} infinite={false}>
        <SkeletonCard>{children}</SkeletonCard>
        <SkeletonCard>{children}</SkeletonCard>
        <SkeletonCard>{children}</SkeletonCard>
        <SkeletonCard>{children}</SkeletonCard>
      </Slider>
    </Grid>
  );
};

export default SkeletonGrid;



// WEBPACK FOOTER //
// ./src/components/Skeleton/SkeletonGrid.jsx